import { Integration } from "@/types/general";
import { Skeleton } from "@mui/material";
import BaseIntegrationInject from "@reusables/BaseIntegrationInject";

interface BaseIntegrationIconProps {
    integration: Integration.Components.Slug;
}

export default function BaseIntegrationIcon({
    integration,
}: BaseIntegrationIconProps) {
    return (
        <BaseIntegrationInject integration={integration}>
            {(integrationData, isLoading) => {
                if (isLoading) {
                    return (
                        <Skeleton
                            variant="circular"
                            width={20}
                            height={20}
                            className="rounded"
                        />
                    );
                }

                return (
                    <div className="w-5 h-5 rounded border border-[#D9DAFD] p-0.5 flex items-center justify-center bg-white">
                        <div
                            className="w-4 h-4 rounded bg-cover bg-center"
                            style={{
                                backgroundImage: `url(${integrationData?.imageUrl})`,
                            }}
                        />
                    </div>
                );
            }}
        </BaseIntegrationInject>
    );
}
